import React from 'react';

import SectionNextmineFooter from './SectionNextmineFooter';

// Nextmine: brug vores egen branded footer i stedet for den Console-hostede
// (som viste rå "[Terms]"-links). Giver fuld kontrol + rigtige links.
const FooterComponent = () => {
  return <SectionNextmineFooter />;
};

// NOTE: if you want to add dynamic data to FooterComponent,
//       you could just connect this FooterContainer to Redux Store
//
// const mapStateToProps = state => {
//   const { currentUser } = state.user;
//   return { currentUser };
// };
// const FooterContainer = compose(connect(mapStateToProps))(FooterComponent);
// export default FooterContainer;

export default FooterComponent;
